<script>
  import cardDiscountTicket from '@/components/card-discount-ticket.vue'
  export default {
    name: 'DiscountTickets',
    components: { cardDiscountTicket },
    data: () => ({
      tickets: [
        {
          details: [
            'Available while supplies last.',
            'Adult residents may purchase a maximum of 6 tickets.',
            'Valid daily from June 1 through September 1 with the exception of June 2, 9, 16 and July 22. Weekends through October 5, 2025. After this date, tickets may be applied to in-park admission at Adventureland only - see rear of ticket for specific details. ',
            'Contact park for hours and weather closures.'
          ],
          discount: '',
          expiration: 'varying',
          homepage: 'https://adventureland.us/',
          logo: 'https://media.eipl.org/site/images/tickets/adventureland-logo.png',
          price: '$31.50',
          slug: 'adventureland',
          title: 'Adventureland',
          ticket_url: 'eipl'
        },
        {
          details: [
            'Use the code: LINYPL15 for 15% off.',
            'Follow the instructions under Special Discount Programs.',
            'Valid for the selected date only.',
            'Cannot be combined with any other offer .'
          ],
          discount: '15%',
          expiration: '',
          homepage: 'https://myadventurepark.com/location/wheatley-heights-ny/',
          logo: 'https://media.eipl.org/site/images/tickets/adventurepark.jpg',
          price: '',
          slug: 'adventure-park',
          title: 'The Adventure Park at Long Island',
          ticket_url: 'https://myadventurepark.com/location/wheatley-heights-ny/prices-promos/discounts/'
        },
        {
          details: [
            "Redeemable for free admission to the permanent collection as well as one special exhibition or show of the ticket holder's choice.",
            'To schedule admission, ticket holders must contact the museum (follow home link below).'
          ],
          discount: '',
          expiration: 'March 2026',
          homepage: 'https://www.amnh.org/plan-your-visit',
          logo: 'https://media.eipl.org/site/images/tickets/AMNHlogo.jpg',
          price: '$10',
          slug: 'amnh',
          title: 'American Museum of Natural History',
          ticket_url: 'eipl'
        },
        {
          details: [
            'Use the code: EISPCM for 25% off Main Stage Show Standard Priced Tickets, apply code at cart.',
            'Limit of 6 tickets per purchase. ',
            'Not valid on VIP seating, prior purchases, or combined with any other offer or discount.'
          ],
          discount: '25%',
          expiration: '',
          homepage: 'https://www.cmpac.com/',
          logo: 'https://media.eipl.org/site/images/tickets/cmcenterlogo.jpg',
          price: '',
          slug: 'cm-center',
          title: 'CM Performing Arts Center',
          ticket_url: 'https://www.cmpac.com/'
        },
        // {
        //   details: [
        //     'Grants up to 6 people one-day admission.',
        //     'Enjoy a $5 discount on any U-Pick Bouquet when you reserve through the library.',
        //     'Include East Islip Library as your Library Name at checkout.'
        //   ],
        //   discount: '',
        //   expiration: '',
        //   homepage: 'https://www.hortonsflowerfarm.com',
        //   logo: 'https://media.eipl.org/site/images/tickets/hortonsfarm.jpg',
        //   price: 'Free',
        //   slug: 'hortons-farm',
        //   title: "Horton's Flower Farm",
        //   ticket_url: 'https://www.hortonsflowerfarm.com/product/reserve-your-u-pick-time-slot-libraries/'
        // },
        {
          details: ['Please contact the Aquarium before your visit to learn about admission procedures.'],
          discount: '',
          expiration: '',
          homepage: 'https://www.longislandaquarium.com/',
          logo: 'https://media.eipl.org/site/images/tickets/LIAquarium.jpg',
          price: '$28 child/senior, $39 adult',
          slug: 'li-aquarium',
          title: 'Long Island Aquarium',
          ticket_url: 'eipl'
        },
        {
          details: ['Please contact the Long Island Science Center before your visit to learn about admission procedures.'],
          discount: '',
          expiration: '',
          homepage: 'https://www.sciencecenterli.org/',
          logo: 'https://media.eipl.org/site/images/tickets/LISC-Logo.jpg',
          price: '$10',
          slug: 'li-science-center',
          title: 'Long Island Science Center',
          ticket_url: 'eipl'
        },
        {
          details: [
            'Follow the direct link below or select "Buy Tickets > Tickets > Any Day Ticket" from the home page menu.',
            'Select how many "Corporate Partner" tickets you would like.',
            'Enter "EASTISLIP25" in the Discounts Promotional code field.',
            'Promo code is CASE SENSITVE!'
          ],
          discount: '',
          expiration: 'varying',
          homepage: 'https://www.splishsplash.com/',
          logo: 'https://media.eipl.org/site/images/tickets/splishsplash.png',
          price: '$44.99 per ticket',
          slug: 'splish-splash',
          title: 'Splish Splash Water park',
          ticket_url: 'https://www.splishsplash.com/buy-tickets/open-day/select-visitors'
        },
        // {
        //   details: [
        //     'Good for one visit to both Riverhead and Greenport locations.',
        //     'Visits to each location can be the same or different dates.',
        //     'Please see their website for more information.'
        //   ],
        //   discount: '',
        //   expiration: 'December 2024',
        //   homepage: 'https://rmli.org/',
        //   logo: 'https://media.eipl.org/site/images/tickets/railroadmuseum.jpg',
        //   price: '$18',
        //   slug: 'railroad-museum',
        //   title: 'Railroad Museum of L.I.',
        //   ticket_url: 'eipl'
        // },

        {
          details: [
            'Includes Bronx Zoo, Central Park Zoo, NY Aquairum, Prospect Park zoo, Queens Zoo and more!',
            'Enter Promo code "EIPL" on checkout page.',
            'Valid for date/time selected only.',
            'Discount cannot be combined with any other offer, promotion, or discount. ',
            'Some attractions are only open seasonally. Camel Ride not included in premium attractions at Bronx Zoo.',
            'All sales are final. No refunds or exchanges.'
          ],
          discount: '',
          expiration: '',
          homepage: 'https://bronxzoo.com',
          logo: 'https://media.eipl.org/site/images/tickets/wcs.jpg',
          price: 'Prices Vary',
          slug: 'wcs',
          title: 'Wildlife Conservation Society',
          ticket_url: 'https://ticketing.wcs.org/WebStore/shop/PromotionCode.aspx?PromotionID=1&CG=AFFSALES&C=AFFTIXWCS'
        }
        // {
        //   details: [],
        //   discount: '',
        //   expiration: '',
        //   homepage: '',
        //   logo: 'https://media.eipl.org/site/images/tickets/',
        //   price: '',
        //   slug: '',
        //   title: '',
        //   ticket_url: ''
        // }
      ]
    }),
    computed: {},
    methods: {},
    created() {}
  }
</script>

<template>
  <v-container class="d-flex flex-column align-center mb-12 rounded-lg">
    <h1 class="text-h2 text-center primary--text font-weight-bold">Discount Tickets</h1>

    <v-card max-width="850" width="100%" class="mt-12">
      <v-card-text class="primary--text">
        <img height="150px" width="150px" src="https://media.eipl.org/site/images/tickets/admit-one.png" class="d-block mx-auto mt-4 mb-12" />
        <p class="text-body-1 primary--text font-weight-black mb-2">The library offers tickets to a variety of local attractions at a discounted rate for our patrons.</p>
        <p class="primary--text text--lighten-2 font-weight-bold">* Please note some locations require a reservation date or special instructions when purchased.</p>
        <ul class="primary-text py-4">
          <li>Patrons must have an adult East Islip Library Card to purchase discount tickets.</li>
          <li>These tickets are available at the Library's Circulation Desk.</li>
          <li>There is a limit of 6 tickets per family, per month.</li>
        </ul>
      </v-card-text>
      <v-card-actions class="primary--text text-center">
        <v-btn color="primary" outlined to="/services/museum-passes" class="mx-2"> <v-icon left>mdi-bank</v-icon>MUSEUM PASSES</v-btn>
        <p class="mb-0">are also available!</p>
      </v-card-actions>
    </v-card>
    <v-sheet color="transparent" class="my-8"></v-sheet>
    <card-discount-ticket v-for="ticket in tickets" :key="ticket.slug" :ticket="ticket" />

    <v-sheet color="transparent" class="my-8"></v-sheet>
  </v-container>
</template>

<style scoped>
  p {
    margin: 0;
  }
</style>
